<template>
  <div class="mask_main" v-if="isShowMask" @click="CloseAlert">
    <div class="mask_model"></div>
    <el-alert v-if="!error" :title="text" type="success" show-icon class="mask_alert" @close="CloseAlert"></el-alert>
    <el-alert v-if="error" :title="text" class="mask_alert" type="error" show-icon @close="CloseAlert"></el-alert>
  </div>
</template>

<script>
export default {
  name: "MaskModel",
  props: {
    isShowMask: {
      type: Boolean,
      default: false
    },
    text:{
      type:String,
      default:"导入成功"
    },
    error:{
      type:Boolean,
      default:false
    },
  },
  methods: {
    CloseAlert() {
      this.$emit("cancelMask", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.mask_main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1001;
  .mask_alert {
    width: 30%;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style lang="scss">
.mask_main .mask_alert .el-alert__closebtn {
  top: 20px;
}
</style>